/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  CreateOrganization,
  JSONDocument,
  List,
  MemberRoleOrGuest,
  MergeRulesStandaloneConfiguration,
  Organization,
  OrganizationAgentInstructions,
  OrganizationAllContent,
  OrganizationDefaultContent,
  OrganizationEmailDomains,
  OrganizationHostname,
  OrganizationTitle,
  SearchSpaceResult,
  URL,
} from "./data-contracts";

/**
 * No description
 * @tags organizations, critical
 * @name ListOrganizationsForAuthenticatedUser
 * @summary Get the list of organizations for the currently authenticated user
 * @request GET:/orgs
 * @secure
 */

// @ts-ignore
export const listOrganizationsForAuthenticatedUser: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {};
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Organization[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs",
  method: "get",
  streaming: false,
  tags: ["organizations", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags organizations, internal
 * @name CreateOrganization
 * @summary Create an organization
 * @request POST:/orgs
 * @secure
 */

// @ts-ignore
export const createOrganization: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {};
  RequestBody: CreateOrganization;
  RequestHeaders: {};
  ResponseBody: Organization;
  ResponseStatusCode: 201;
} = {
  route: "/orgs",
  method: "post",
  streaming: false,
  tags: ["organizations", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations, critical
 * @name GetOrganizationById
 * @summary Get an organization by its ID
 * @request GET:/orgs/{organizationId}
 * @secure
 */

// @ts-ignore
export const getOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Organization;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}",
  method: "get",
  streaming: false,
  tags: ["organizations", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags organizations, internal
 * @name DeleteOrganizationById
 * @summary Delete an organization
 * @request DELETE:/orgs/{organizationId}
 * @secure
 */

// @ts-ignore
export const deleteOrganizationById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}",
  method: "delete",
  streaming: false,
  tags: ["organizations", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations
 * @name UpdateOrganizationById
 * @summary Update an organization
 * @request PATCH:/orgs/{organizationId}
 * @secure
 */

// @ts-ignore
export const updateOrganizationById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Name of the organization */
    title?: OrganizationTitle;
    emailDomains?: OrganizationEmailDomains;
    /** Default hostname for the organization's public content, e.g. <org-hostname>.gitbook.io */
    hostname?: OrganizationHostname;
    /** The role of a member in an organization, null for guests */
    defaultRole?: MemberRoleOrGuest;
    defaultContent?: OrganizationDefaultContent | null;
    logo?: URL | null;
    sso?: boolean;
    ai?: boolean;
    inviteLinks?: boolean;
    mergeRules?: MergeRulesStandaloneConfiguration;
  };
  RequestHeaders: {};
  ResponseBody: Organization;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}",
  method: "patch",
  streaming: false,
  tags: ["organizations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists all spaces, collections, sites accessible by current user in the current organization. This endpoint is internal for now as the data structure is optimized for the sidebar.
 * @tags organizations, critical, internal
 * @name GetOrganizationAllContent
 * @summary List all content in an organization
 * @request GET:/orgs/{organizationId}/content
 * @secure
 */

// @ts-ignore
export const getOrganizationAllContent: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationAllContent;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/content",
  method: "get",
  streaming: false,
  tags: ["organizations", "critical", "internal"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags organizations
 * @name DeleteOrganizationInviteById
 * @summary Deletes an organization invite.
 * @request DELETE:/orgs/{organizationId}/link-invites/{inviteId}
 * @secure
 */

// @ts-ignore
export const deleteOrganizationInviteById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the invite */
    inviteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/link-invites/{inviteId}",
  method: "delete",
  streaming: false,
  tags: ["organizations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Join an organization if the user's verified email domain matches one of the organization's allowed email domains. This endpoint allows existing users to join organizations they're eligible for based on their email domain.
 * @tags organizations
 * @name JoinOrganization
 * @summary Join an organization
 * @request POST:/orgs/{organizationId}/join
 * @secure
 */

// @ts-ignore
export const joinOrganization: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/join",
  method: "post",
  streaming: false,
  tags: ["organizations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Send a request to ask the organization's admin to upgrade it.
 * @tags organizations, internal
 * @name RequestOrganizationUpgrade
 * @summary Request organization upgrade
 * @request POST:/orgs/{organizationId}/request_upgrade
 * @secure
 */

// @ts-ignore
export const requestOrganizationUpgrade: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The feature key the user is asking an organization upgrade for */
    featureKey?: string;
  };
  RequestHeaders: {};
  ResponseBody: object;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/request_upgrade",
  method: "post",
  streaming: false,
  tags: ["organizations", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations
 * @name SearchOrganizationContent
 * @summary Search content in an organization
 * @request GET:/orgs/{organizationId}/search
 * @secure
 */

// @ts-ignore
export const searchOrganizationContent: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** @maxLength 512 */
    query: string;
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SearchSpaceResult[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/search",
  method: "get",
  streaming: false,
  tags: ["organizations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations, agents
 * @name GetOrganizationAgentInstructions
 * @summary Get Docs agent instructions for an organization
 * @request GET:/orgs/{organizationId}/agent-instructions
 * @secure
 */

// @ts-ignore
export const getOrganizationAgentInstructions: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationAgentInstructions;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/agent-instructions",
  method: "get",
  streaming: false,
  tags: ["organizations", "agents"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations, agents
 * @name UpdateOrganizationAgentInstructions
 * @summary Update Docs agent instructions for an organization
 * @request PUT:/orgs/{organizationId}/agent-instructions
 * @secure
 */

// @ts-ignore
export const updateOrganizationAgentInstructions: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Document describing the Docs agent instructions. */
    instructions: JSONDocument;
  };
  RequestHeaders: {};
  ResponseBody: OrganizationAgentInstructions;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/agent-instructions",
  method: "put",
  streaming: false,
  tags: ["organizations", "agents"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations
 * @name GetOrganizationsForEmailDomain
 * @summary Get all organizations by email domain
 * @request GET:/email-domains/{emailDomain}/orgs
 * @secure
 */

// @ts-ignore
export const getOrganizationsForEmailDomain: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** Email domain */
    emailDomain: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    organizations: Organization[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/email-domains/{emailDomain}/orgs",
  method: "get",
  streaming: false,
  tags: ["organizations"],
  criticalityLevel: "low",
  deprecated: false,
};
